import axios from 'axios';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies, import/extensions
import config from 'config';

const state = {
	polls: {},
	poll: {},
	answers: {},
	condition: {},
	groups: [],
	group: {
		name: '',
		filter: {
			operator: 'AND',
			rules: [
				{
					name: '',
					data: {
						field: '',
						value: '',
					},
				},
			],
		},
	},
	deleteGroup: '',
	groupIdCreated: '',
	countRecipients: '',
	recipients: {},
	detailsMessage: {},
};

const actions = {
	getPoll: ({ commit, rootState }, payload) => new Promise((resolve, reject) => {
		axios.get(`${config.api}/politician/${rootState.userId}/poll/${payload.pollId}?api_key=${rootState.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('setPoll', response.data, { root: true });
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.status);
			});
	}),
	getCondition: ({ commit }, payload) => {
		axios
			.get(`${config.api}/politician/${
				payload.userId
			}/group/structure?api_key=${payload.apiKey}`)
			.then((response) => {
				commit('getCondition', response.data, { root: true });
			}).catch((error) => {
				commit('statusCheck', error.response.status);
			});
	},
	getAnswers: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios.get(`${config.api}/politician/${rootState.userId}/poll/${payload.poll}/questions/${payload.question}?api_key=${rootState.apiKey}`)
				.then((response) => {
					resolve(response);
					commit('setAnswers', response.data, { root: true });
				}).catch((error) => {
					reject(error);
					commit('statusCheck', error.response.status);
				});
		}),
	createNewGroup: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios({
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				url: `${config.api}/politician/${rootState.userId}/group?api_key=${rootState.apiKey}`,
				data: payload,
			}).then(
				(response) => {
					resolve(response);
					commit('setFilters', response.data);
				},
				(error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				},
			);
		}),
	calculateRecipientsGroup: ({ commit }, payload) =>
		new Promise((resolve) => {
			const data = {
				filter: {
					rules: payload.rules.filter(f => f.data.field !== '' && f.name !== ''),
					operator: payload.operator,
				},
			};

			if (data.filter.rules.length > 0) {
				axios({
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					url: `${config.api}/politician/${
						payload.session.userId
					}/group/count?api_key=${payload.session.apiKey}`,
					data,
				}).then(
					(response) => {
						resolve(response);
						commit('setCalculateRecipientsGroup', response.data);
					},
					(error) => {
						commit('setError', error.response.data);
						commit('statusCheck', error.response.status);
					},
				);
			}
		}),
	getGroups: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(`${config.api}/politician/${payload.userId}/group?api_key=${payload.apiKey}`)
			.then((response) => {
				resolve(response.data);
				commit('setGroups', response.data);
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.status);
			});
	}),
	getGroupsList: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(`${config.api}/politician/${payload.userId}/group?api_key=${payload.apiKey}&page=${payload.page}&results=${payload.results}`)
			.then((response) => {
				resolve(response.data);
				commit('setGroupsList', response.data);
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.status);
			});
	}),
	getGroup: ({ commit }, payload) =>
		new Promise((resolve, reject) => {
			axios
				.get(`${config.api}/politician/${payload.userId}/group/${
					payload.groupId
				}?api_key=${payload.apiKey}`)
				.then(
					(response) => {
						resolve(response);
						commit('setGroup', response.data);
					},
					(error) => {
						reject(error);
						commit('statusCheck', error.response.status);
					},
				);
		}),
	paginateGroup: ({ commit }, payload) =>
		new Promise((resolve) => {
			axios
				.get(`${config.api}/politician/${payload.userId}/group/${
					payload.idCategory
				}?api_key=${payload.apiKey}&page=${payload.page}&results=${
					payload.results
				}`)
				.then(
					(response) => {
						resolve(response);
						commit('recipients', response.data.recipients);
					},
					(error) => {
						commit('statusCheck', error.response.status);
					},
				);
		}),
	editGroup: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios({
				method: 'PUT',
				headers: { 'Content-Type': 'application/json' },
				url: `${config.api}/politician/${rootState.userId}/group/${payload.groupId}/?api_key=${rootState.apiKey}`,
				data: payload,
			}).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				},
			);
		}),
	deleteGroup({ commit }, payload) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
				},
				url: `${config.api}/politician/${
					payload.session.userId
				}/group/${payload.groupid}/?api_key=${payload.session.apiKey}`,
			}).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				},
			);
		});
	},
	setRecipientToGroup: ({ commit, rootState }, payload) => {
		return new Promise((resolve, reject) => {
			axios({
				method: 'POST',
				url: `${config.api}/politician/${rootState.userId}/recipients/${payload.recipientId}/group?groups=[${payload.groupId}]&api_key=${rootState.apiKey}`,
			}).then((response) => {
				resolve(response);
				commit('setRecipientToGroup');
				commit('setSuccess', response.data);
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data, { root: true });
				commit('statusCheck', error.response.status);
			});
		});
	},
};

const mutations = {
	setPolls: (state, payload) => {
		state.polls = payload;
	},
	setPoll: (state, payload) => {
		state.poll = payload;
	},
	getCondition: (state, payload) => {
		state.condition = payload.valid_rules;
	},
	setAnswers: (state, payload) => {
		state.answers = payload;
	},
	setFilters: (state, payload) => {
		state.groupIdCreated = payload;
	},
	setCalculateRecipientsGroup: (state, payload) => {
		state.countRecipients = payload.count;
	},
	setGroups: (state, payload) => {
		state.groups = payload;
	},
	setGroupsList: (state, payload) => {
		state.groups = payload;
	},
	setGroup: (state, payload) => {
		state.group = payload;
	},
	deleteGroup: (state, payload) => {
		state.deleteGroup = payload;
	},
	recipients: (state, payload) => {
		state.recipients = payload;
	},
	updateGroupName: (state, payload) => {
		state.group.name = payload;
	},
	updateGroupFilterOperator: (state, payload) => {
		state.group.filter.operator = payload;
	},
	updateGroupRules: (state, payload) => {
		state.group.filter.rules = payload;
	},
	statusCheck: (state, payload) => {
		if (payload === 403) {
			sessionStorage.setItem('statusCode', payload);
		}
	},
	resetGroup: (state, payload) => {
		state.group.filter = payload;
	},
	resetGroupName: (state, payload) => {
		state.group.name = payload;
	},
	setRecipientToGroup: (state, payload) => {
		state.detailsMessage = payload;
	},
};

export default {
	state,
	mutations,
	actions,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/group/store.js